import React from "react";
import { SNS_OPTIONS } from "../../utils/formUtils";

const SnsLinksInput = ({ snsLinks, onChange }) => {
  const handleAdd = () =>
    onChange([...snsLinks, { platform: "instagram", url: "" }]);

  const handleRemove = (index) =>
    onChange(snsLinks.filter((_, i) => i !== index));

  const handleChange = (index, field, value) => {
    const updated = snsLinks.map((link, i) =>
      i === index ? { ...link, [field]: value } : link,
    );
    onChange(updated);
  };

  return (
    <div className="snsLinksInput">
      {snsLinks.map((link, i) => (
        <div key={i} className="snsLinksInput__item">
          <select
            className="snsLinksInput__platform"
            value={link.platform}
            onChange={(e) => handleChange(i, "platform", e.target.value)}
          >
            {SNS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <input
            type="url"
            className="snsLinksInput__url"
            placeholder="https://..."
            maxLength={500}
            value={link.url}
            onChange={(e) => handleChange(i, "url", e.target.value)}
          />
          <button
            type="button"
            className="snsLinksInput__remove"
            onClick={() => handleRemove(i)}
          >
            削除
          </button>
        </div>
      ))}
      {snsLinks.length < 8 && (
        <button
          type="button"
          className="snsLinksInput__add"
          onClick={handleAdd}
        >
          + SNSを追加
        </button>
      )}
    </div>
  );
};

export default SnsLinksInput;
